<template>
  <b-tab
      data-is-activity-tab="true"
      @click="clicked"
  >
    <template #title>
      {{ title }}
      <tab-icon :status="error ? 'ERROR' :
                         edited ? 'EDITED' : ''"></tab-icon>
    </template>
    <slot>


    </slot>
  </b-tab>
</template>

<script>
import TabIcon from "@/components/layout/TabIcon";
export default {
  name: "ActivityTab",
  components: {TabIcon},
  created() {
    let contentComponents = this.$slots.default;
    for(const vNode of contentComponents){

    }
  },
  methods:{
    clicked(){
      this.$emit("activated")
    }
  },
  props:{
    title:{default:""},
    icon:{default:""},
    edited:{default:false},
    error:{default:false},

  }
}
</script>

<style scoped>

</style>